<template>
  <van-tabbar v-show="$route.meta.showTab" route v-model="active" active-color="#2B6CF9" inactive-color="#CBD1DE" :z-index="999">
    <van-tabbar-item replace :to="item.path" v-for="(item,index) in tabData" :key="index" @click="setTitle()">
      <span>{{item.name}}</span>
      <img slot="icon" slot-scope="props"
           :src="props.active ? item.selectedIconPath : item.iconPath"/>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
//  import Vue from 'vue'
//  import { Tabbar, TabbarItem } from 'vant'
//  Vue.use(Tabbar).use(TabbarItem)

  export default {
    components: {},
    props:{
      tabData:{
        type: Array
      }
    },
    data () {
      return {
        active: 1
      }
    },
    methods: {
      setTitle(){
        console.log(12)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
</style>

